module.exports = __webpack_public_path__ + "static/media/id-card.e1612f91.svg";